import http from 'utils/http';
import { downloadHeader } from 'utils/download';

export const getSortingFacilityData = (params) => {
  return http.get(`/hubs/sorting-facility-ops-room-report`, params);
};

export const exportTableData = (payload) => {
  return http.post('deliveries/exportxlsx?', payload, downloadHeader);
};

export const inTransitDeliveriesCount = (payload) => {
  return http.get('hubs/in-transit-ops-room-report', payload);
};

export const exportInTransitReport = (payload) => {
  return http.get(
    'hubs/export-in-transit-ops-room-report',
    payload,
    downloadHeader
  );
};

export const getHubDeliveries = (id, payload) => {
  return http.get(`hubs/${id}/in-transit-ops-room-deliveries`, payload);
};

export const exportHubDeliveries = (id, payload) => {
  return http.get(`hubs/${id}/export-in-transit-ops-room-deliveries`, payload);
};

export const exportAllHubsDeliveries = (payload) => {
  return http.get('hubs/export-in-transit-ops-room-deliveries', payload);
};

export const getDispatchingOpsRoom = (payload) => {
  return http.get(`hubs/dispatching-ops-room-report`, payload);
};

export const exportDispatchingOpsRoom = (payload) => {
  return http.get(
    `hubs/export-dispatching-ops-room-report`,
    payload,
    downloadHeader
  );
};

export const getDispatchingRoomDeliveries = (id, payload) => {
  return http.get(`hubs/${id}/dispatching-ops-room-deliveries`, payload);
};

export const exportDispatchingRoomDeliveries = (payload, id) => {
  return http.get(`hubs/${id}/export-dispatching-ops-room-deliveries`, payload);
};

export const exportDispatchingAllHubsDeliveries = (payload) => {
  return http.get('hubs/export-dispatching-ops-room-deliveries', payload);
};

export const getSortingFacilityDeliveries = (payload) => {
  return http.get('hubs/sorting-facility-ops-room-deliveries', payload);
};

export const exportSortingFacilityData = (payload) => {
  return http.get('hubs/export-sorting-facility-ops-room-deliveries', payload);
};

export const fetchDeliveriesCount = (payload) => {
  return http.get('hubs/sorting-facility-ops-room-deliveries-count', payload);
};

export const getCurrentActiveDate = (payload, options = {}) => {
  return http.get('hubs/ops-room-active-date', payload, options);
};

export const getWrongZoneOrders = ({ page, limit, ...args }) => {
  return http.get('/hubs/wrong-zone-ops-room-deliveries', {
    skip: (page - 1) * limit,
    limit,
    ...args
  });
};

export const getWrongZoneOrdersCount = (payload) => {
  return http.get('/hubs/wrong-zone-ops-room-deliveries-count', payload);
};

export const exportWrongZoneOrders = (payload) => {
  return http.get('/hubs/export-wrong-zone-ops-room-deliveries', payload);
};

export const assignWrongZoneOrderHub = (orderRowId, hubId) => {
  return http.post(
    `/hubs/wrong-zone-ops-room-deliveries/${orderRowId}/force-assign-to-hub`,
    { hubId }
  );
};

export const assignWrongZoneBulkOrders = (payload) => {
  return http.post(
    '/hubs/wrong-zone-ops-room-deliveries/force-assign-to-hub-bulk',
    payload
  );
};

export const getLostOrdersPendingOnHub = (payload) => {
  return http.get(`/hubs/lost-ops-room-deliveries`, payload);
};

export const getLostOrdersPendingOnFleet = (payload) => {
  return http.get(`/hubs/lost-ops-room-deliveries-pending-on-stars`, payload);
};

export const getLostOrdersPendingOnAudit = (payload) => {
  return http.get(`/hubs/lost-ops-room-deliveries-pending-on-audit`, payload);
};

export const getLostOrdersPendingOnUnknown = (payload) => {
  return http.get(`/hubs/lost-ops-room-deliveries-pending-on-unknown`, payload);
};

export const getConfirmedLostOrders = (payload) => {
  return http.get(`/hubs/lost-ops-room-confirmed-lost-deliveries`, payload);
};

export const markAsFound = (payload, deliveryId) => {
  return http.post(`/admin/deliveries/${deliveryId}/mark-as-found`, payload);
};

export const markStarAsLiable = (payload, deliveryId) => {
  return http.post(
    `/admin/deliveries/${deliveryId}/mark-as-star-is-liable`,
    payload
  );
};

export const markHubAsLiable = (payload, deliveryId) => {
  return http.post(
    `/admin/deliveries/${deliveryId}/mark-as-hub-is-liable`,
    payload
  );
};

/**
 * @param {{ starId: string }} payload - The star ID to mark as liable
 */
export const confirmStarIsLiable = (payload, deliveryId) => {
  return http.post(
    `/admin/deliveries/${deliveryId}/mark-as-confirmed-lost-by-star`,
    payload
  );
};

export const lostOrdersPendingOnHubCount = (payload) => {
  return http.get(`/hubs/lost-ops-room-deliveries-count`, payload);
};

export const lostOrdersPendingOnFleetCount = (payload) => {
  return http.get(
    `/hubs/lost-ops-room-deliveries-pending-on-stars-count`,
    payload
  );
};

export const lostOrdersPendingOnAuditCount = (payload) => {
  return http.get(
    `/hubs/lost-ops-room-deliveries-pending-on-audit-count`,
    payload
  );
};

export const lostOrdersPendingOnUnknownCount = (payload) => {
  return http.get(
    `/hubs/lost-ops-room-deliveries-pending-on-unknown-count`,
    payload
  );
};

export const confirmedLostOrdersCount = (payload) => {
  return http.get(
    `/hubs/lost-ops-room-confirmed-lost-deliveries-count`,
    payload
  );
};

export const exportLostOrders = (payload) => {
  return http.get(`/hubs/export-lost-ops-room-deliveries`, payload);
};

export const getProofImages = (deliveryId) => {
  return http.get(`/admin/deliveries/${deliveryId}/proof-of-liability-images`);
};

export const getProofOfFoundImages = (deliveryId) => {
  return http.get(
    `/admin/deliveries/${deliveryId}/proof-of-found-delivery-images`
  );
};

export const getProductDetails = (deliveryId) => {
  return http.get(`/admin/deliveries/${deliveryId}/productsDetails`);
};

export const getProofOfReturnedPackagesImages = (deliveryId) => {
  return http.get(
    `/admin/deliveries/${deliveryId}/business-proof-of-returned-packages-images`
  );
};

/**
 * @param {string} deliveryId - The delivery ID to approve found
 */
export const approveFound = (deliveryId) => {
  return http.post(`/admin/deliveries/${deliveryId}/mark-as-confirmed-found`);
};

/**
 * @param {string} deliveryId - The delivery ID to confirm lost
 */
export const confirmLost = (deliveryId, payload) => {
  return http.post(
    `/admin/deliveries/${deliveryId}/mark-as-confirmed-lost`,
    payload
  );
};

export const markAsConfirmedLostFromUnknown = (deliveryId, payload) => {
  return http.post(
    `/admin/deliveries/${deliveryId}/mark-as-confirmed-lost-from-unknown-hub`,
    payload
  );
};

export const markBulkDeliveriesAsLost = (payload) => {
  return http.post(
    '/admin/deliveries/markBulkDeliveriesAsLostFromHub',
    payload
  );
};
